define( function() {

"use strict";

// https://www.w3.org/TR/css3-selectors/#whitespace
return "[\\x20\\t\\r\\n\\f]";

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/whitespace.js
// module id = 180
// module chunks = 0